import userSlice from './user';
import persistedSlice from './persisted';
import candidateSlice from './candidate';
import starredCandidateSlice from './starredCandidates';
import tagsSlice from './tags';
import threadSlice from './thread';
import campaignsSlice from './campaign';
import dlcFormSlice from './dlcForm';
import customerSlice from './customer';
import reportingSlice from './reporting';
import metricsSlice from './metrics';
import scheduleMessageSlice from './scheduleMessage';
import eventsSlice from './events';
import jobChatSlice from './JobChat';
import facebookSlice from './facebook';
import teamsSlice from './teams';
import wechatSlice from './wechat';
import whatsAppSelfServiceSlice from './whatsappSelfService';

import { logout, fetchTokenInfo, sessionInfo } from 'redux/actions';
import { combineReducers } from '@reduxjs/toolkit';

const appReducer = combineReducers({
  user: userSlice.reducer,
  candidate: candidateSlice.reducer,
  starredCandidates: starredCandidateSlice.reducer,
  tags: tagsSlice.reducer,
  campaigns: campaignsSlice.reducer,
  dlcForm: dlcFormSlice.reducer,
  thread: threadSlice.reducer,
  customer: customerSlice.reducer,
  reporting: reportingSlice.reducer,
  persisted: persistedSlice.reducer,
  jobChat: jobChatSlice.reducer,
  metrics: metricsSlice.reducer,
  scheduleMessage: scheduleMessageSlice.reducer,
  events: eventsSlice.reducer,
  facebook: facebookSlice.reducer,
  team: teamsSlice.reducer,
  wechat: wechatSlice.reducer,
  whatsAppSelfService: whatsAppSelfServiceSlice.reducer,

  /**
   * TODO: Leave this sample code here for when we begin
   * migrating state management and caching from async-thunk
   * to rtk-query: https://redux-toolkit.js.org/rtk-query/usage/migrating-to-rtk-query
   */
  // [candidateApi.reducerPath]: candidateApi.reducer,
});

export default function rootReducer(state, action) {
  /**
   * Reset global state and clear window stored data
   *  If user logs out successfully or refreshing token fails
   */
  if (
    logout.fulfilled.match(action) ||
    fetchTokenInfo.rejected.match(action) ||
    sessionInfo.rejected.match(action) ||
    action.type === 'resetState'
  ) {
    // Reducer will return the initial state when it receives undefined,
    // thus resetting the entire global store and booting user off to login page
    /* eslint-disable no-undefined */
    state = undefined;
  }
  return appReducer(state, action);
}
